import AdminModel from '@/models/Admin';
import MemModel from '@/models/Mem';

const GET_FEEDBACK_DICT = 'GET_FEEDBACK_DICT';
const ADD_FEEDBACK = 'ADD_FEEDBACK';

/**
 * 获取意见反馈字典
 */
async function getFeedbackDict() {
  const payload = await new AdminModel().getDicList('CTS_TIP_TYPE');
  return {
    type: GET_FEEDBACK_DICT,
    payload
  }
}

/**
* 提交意见反馈
* @param {number} tipType 意见类型
* @param {string} tip 意见内容
*/
async function addFeedback(tipType, tip) {
  const payload = await new MemModel().addFeedback(tipType, tip);
  return {
    type: ADD_FEEDBACK,
    payload
  }
}

const ACTION_TYPES = {
  GET_FEEDBACK_DICT,
  ADD_FEEDBACK,
};

const ACTION = {
  getFeedbackDict,
  addFeedback,
};

const Feedback = {
  ACTION_TYPES,
  ACTION
}

export default Feedback;